import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { ScheduleTemplate } from 'components/Templates'

const Schedule: FC = () => {
  return (
    <Layout headline={'事前予約日設定'} iconPath={'/icon/white/reservation.svg'} title={'事前予約日設定'}>
      <ScheduleTemplate />
    </Layout>
  )
}

export default Schedule
